import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmployeeService } from 'app/modules/employee/services/employee.service';

@Component({
    selector: 'app-delete-motivo',
    templateUrl: './delete-motivo.component.html',
    styleUrls: ['./delete-motivo.component.scss'],
    standalone: false
})
export class DeleteMotivoComponent implements OnInit {

    form: UntypedFormGroup;


    constructor(
        @Inject(MAT_DIALOG_DATA) private employeeId: number,
        private fb: UntypedFormBuilder,
        private dialogRef: MatDialogRef<DeleteMotivoComponent>,
        private employeeService: EmployeeService,
        private sharedService: SharedService,
    ) { }


    ngOnInit(): void {

        // init form
        this.form = this.fb.group({
            "motivo": [""]
        });

    }


    /**
     * Cancel button click handler
     */
    onCancelButtonClick() {
        this.dialogRef.close();
    }


    /**
     * Accept button click handler
     */
    onAcceptButtonClick() {

        if (this.form.valid) {

            this.employeeService
                .deleteEmployee(this.employeeId, this.form.get("motivo").value)
                .subscribe(res => {

                    if (res.code === 0) {

                        // notify listners and close
                        this.employeeService.isEmployeeDeleted = true;
                        this.dialogRef.close();

                    } else {
                        console.error("Server Error: " + res.message);
                        this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
                    }

                }, err => {
                    console.error("Unknown Error: " + err);
                    this.sharedService.ShowSnackBar("Lo siento, el proceso falló");
                });

        }

    }

}
